import { AxiosInstance, AxiosPromise } from 'axios';
import { fromArrayToCSV } from '@trukt/utils/fromArrayToCSV';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import {
  CreateTerminalContactRequest,
  CreateTerminalContactResponse,
  SearchTerminalContactsRequest,
  SearchTerminalContactsResponse,
  MergeTerminalContactsRequest,
  MergeTerminalContactsResponse,
  TerminalContactGetRequest,
  TerminalContactGetResponse,
  TerminalContactUpdateRequest,
} from './TerminalContactService.types';
import { TerminalContactBulkService } from './services';

export class TerminalContactService implements BaseRequestEndpoints {
  instance: AxiosInstance;
  bulk: TerminalContactBulkService;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.bulk = new TerminalContactBulkService(instance);
  }

  create(request: CreateTerminalContactRequest) {
    return this.instance.post<CreateTerminalContactResponse>(
      `/terminals/${request.routeParams.terminalId}/contacts`,
      request.body,
    );
  }

  getById(request: TerminalContactGetRequest) {
    return this.instance.get<TerminalContactGetResponse>(
      `/terminals/${request.terminalId}/contacts/${request.contactId}`,
    );
  }

  search(request: SearchTerminalContactsRequest) {
    return this.instance.get<SearchTerminalContactsResponse>(
      `/terminals/${request.routeParams.terminalId}/contacts`,
      {
        params: { ...request.queryParams, search: fromArrayToCSV(request.queryParams.search) },
      },
    );
  }

  update(request: TerminalContactUpdateRequest) {
    return this.instance.patch(
      `/terminals/${request.routeParams.terminalId}/contacts/${request.routeParams.contactId}`,
      request.body,
    );
  }

  delete(): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  merge(request: MergeTerminalContactsRequest) {
    return this.instance.put<MergeTerminalContactsResponse>(
      `/contacts/${request.routeParams.contactGuid}/merge`,
      request.body,
    );
  }
}
